import React from "react";
import { btnDraftType } from "../../../utils/constant";
import RtoDetailsCheck from "./RtoDetailsCheck";
import Ownership from "./Ownership";
import InsuranceCheck from "./InsuranceCheck";
import DisbursalDetailCheck from "./DisbursalDetailCheck";
import PreviousLoan from "./PreviousLoan";
import BuyerDetailsCheck from "./BuyerDetailsCheck";
import OtherVerification from "./OtherVerification";
import PaymentTranche from "./PaymentTrancheForm/PaymentTranche";

const DetailForm = ({
  caseDetails,
  paymentdetails,
  user,
  selectedPanel,
  stepSelected,
  stepObj,
  formFieldValues,
  handleNextStep,
  controlsystem,
  payleadData,
  RCLimit,
  fetchDetails,
  isMoneyReturnToBank,
  changeMoneyReturnToBank,
  fetchCaseData,
  fetchGallery,
}) => {
  const { checkpoints, isVerificationRequired } = formFieldValues;

  const Message = () => (
    <>
      <span className="glyphicon glyphicon-ok-sign"></span>
      Successfully saved
    </>
  );

  return (
    <div className="col-md-4" id="panel-view-html">
      <input
        id="form_type"
        name="form_type"
        type="hidden"
        value={btnDraftType}
        readOnly
      />
      <input
        id="form_stage"
        name="form_stage"
        type="hidden"
        value={formFieldValues.stageDraftVal}
        readOnly
      />
      <input
        id="form_substage"
        name="form_substage"
        type="hidden"
        value={formFieldValues.substageDraftVal}
        readOnly
      />
      <input
        id="form_name"
        name="form_name"
        type="hidden"
        value={stepSelected}
        readOnly
      />
      {/* <input
        id="step"
        name="step"
        type="hidden"
        value={
          selectedPanel === -1
            ? panels[0].panelName
            : panels[selectedPanel].panelName
        }
        readOnly
      /> */}
      <input
        id="insurance"
        name="insurance"
        type="hidden"
        value={caseDetails.insurance}
        readOnly
      />
      <input
        type="hidden"
        id="is_prepayment_raised"
        name="is_prepayment_raised"
        value={caseDetails.is_prepayment_raised}
        readOnly
      />
      <input
        type="hidden"
        id="next_step"
        name="next_step"
        value={stepObj.nextStep}
        readOnly
      />
      <input
        type="hidden"
        id="user_role"
        name="user_role"
        // value={user.dts_user}
        readOnly
      />
      <input
        type="hidden"
        id="paylead_limit"
        name="paylead_limit"
        value={payleadData.payleadLimit}
        readOnly
      />
      <input
        type="hidden"
        id="paylead_user_id"
        name="paylead_user_id"
        value={payleadData.payleadUserId}
        readOnly
      />
      <div className="row">
        <div className="particular-tab-docs" id="checklistD">
          <div className="panel panel-default">
            <div className="panel-body">
              <div className="tab-content">
                <div
                  role="tabpanel"
                  className="tab-pane fade in active"
                  id="tab-particulars-information"
                >
                  {(() => {
                    switch (stepSelected) {
                      case "rto_details_check":
                        return (
                          <RtoDetailsCheck
                            fieldValues={formFieldValues}
                            stepSelected={stepSelected}
                            handleNextStep={handleNextStep}
                            user={user}
                            isVerificationRequired={isVerificationRequired}
                            Message={Message}
                            dtsCheckpoints={checkpoints}
                            fetchCaseData={fetchCaseData}
                            caseDetails={caseDetails}
                          />
                        );
                      case "ownership":
                        return (
                          <Ownership
                            fieldValues={formFieldValues}
                            stepSelected={stepSelected}
                            handleNextStep={handleNextStep}
                            user={user}
                            isVerificationRequired={isVerificationRequired}
                            Message={Message}
                            dtsCheckpoints={checkpoints}
                            fetchCaseData={fetchCaseData}
                            caseDetails={caseDetails}
                          />
                        );
                      case "insurance_check":
                        return (
                          <InsuranceCheck
                            fieldValues={formFieldValues}
                            stepSelected={stepSelected}
                            handleNextStep={handleNextStep}
                            user={user}
                            isVerificationRequired={isVerificationRequired}
                            Message={Message}
                            dtsCheckpoints={checkpoints}
                            fetchCaseData={fetchCaseData}
                            caseDetails={caseDetails}
                          />
                        );
                      case "disbursal_detail_check":
                        return (
                          <DisbursalDetailCheck
                            fieldValues={formFieldValues}
                            stepSelected={stepSelected}
                            handleNextStep={handleNextStep}
                            user={user}
                            isVerificationRequired={isVerificationRequired}
                            Message={Message}
                            dtsCheckpoints={checkpoints}
                            fetchCaseData={fetchCaseData}
                            caseDetails={caseDetails}
                          />
                        );
                      case "previous_loan":
                        return (
                          <PreviousLoan
                            fieldValues={formFieldValues}
                            stepSelected={stepSelected}
                            handleNextStep={handleNextStep}
                            user={user}
                            isVerificationRequired={isVerificationRequired}
                            Message={Message}
                            dtsCheckpoints={checkpoints}
                            fetchCaseData={fetchCaseData}
                            caseDetails={caseDetails}
                          />
                        );
                      case "buyer_details_check":
                        return (
                          <BuyerDetailsCheck
                            fieldValues={formFieldValues}
                            stepSelected={stepSelected}
                            handleNextStep={handleNextStep}
                            user={user}
                            isVerificationRequired={isVerificationRequired}
                            Message={Message}
                            dtsCheckpoints={checkpoints}
                            fetchCaseData={fetchCaseData}
                            caseDetails={caseDetails}
                          />
                        );
                      case "other_verification":
                        return (
                          <OtherVerification
                            fieldValues={formFieldValues}
                            stepSelected={stepSelected}
                            handleNextStep={handleNextStep}
                            user={user}
                            isVerificationRequired={isVerificationRequired}
                            Message={Message}
                            dtsCheckpoints={checkpoints}
                            fetchCaseData={fetchCaseData}
                            caseDetails={caseDetails}
                          />
                        );
                      case "payment_tranche":
                        break;
                      default:
                        return (
                          <RtoDetailsCheck
                            fieldValues={formFieldValues}
                            stepSelected={stepSelected}
                            handleNextStep={handleNextStep}
                            user={user}
                            isVerificationRequired={isVerificationRequired}
                            dtsCheckpoints={checkpoints}
                            fetchCaseData={fetchCaseData}
                            caseDetails={caseDetails}
                          />
                        );
                    }
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {stepSelected === "payment_tranche" ? (
        <PaymentTranche
          fieldValues={formFieldValues}
          paymentDetails={paymentdetails}
          user={user}
          isVerificationRequired={isVerificationRequired}
          Message={Message}
          controlsystem={controlsystem}
          payleadData={payleadData}
          RCLimit={RCLimit}
          fetchDetails={fetchDetails}
          isMoneyReturnToBank={isMoneyReturnToBank}
          changeMoneyReturnToBank={changeMoneyReturnToBank}
          caseDetails={caseDetails}
          fetchGallery={fetchGallery}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default DetailForm;
